// Modal.tsx
import React,{ReactNode} from 'react';


interface ModalProps {
    isOpen: boolean;
    children: ReactNode
    setClose: ()=> void
    propClasses?: string
} 

const Modal: React.FC<ModalProps> = ({ isOpen,  children, setClose, propClasses }) => {


    // const [enableSubmitButton, setEnableSubmitButton] = useState(false);
    // const updatePoaStatusDispatch = useUpdatePoaType();

    // useEffect(() => {
    //     if (poaTime && poaDate) {
    //         setEnableSubmitButton(true);
    //     } else {
    //         setEnableSubmitButton(false);
    //     }
    // }, [poaDate, poaTime]);
  


    if (!isOpen) return null;

    return (
        <div className={`modal-overlay ${propClasses}`} onClick={setClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className='modal-form'>
                {children}
                </div>
            </div>
        </div>
    );
};


export default Modal;
